import { Theme } from '@mui/material/styles';

export default function Accordion(theme: Theme) {
  const { palette } = theme;

  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          border: `1px solid ${palette.grey[400]}`,
          margin: '16px 0',
          borderRadius: theme.shape.borderRadius,
          boxShadow: 'none',
          '&.Mui-expanded': {
            boxShadow: 'none',
            borderColor: 'transparent',
          },
          '&.Mui-disabled': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(1),
          '&.Mui-disabled': {
            opacity: 1,
            color: theme.palette.action.disabled,
            '& .MuiTypography-root': {
              color: 'inherit',
            },
          },
        },
        expandIconWrapper: {
          color: 'inherit',
        },
      },
    },
  };
}
